export default {
  ENABLE_EM: 'enableEM',
  DELETE_BTN: 'deleteBtn',
};
